import classNames from 'classnames';
import { Button } from '@meitu/saas-ui';
import { clientInfo } from '@meitu/pc-bridge';
import { useLocaleStore } from '@/i18n';
import { isIntl } from '@/react-process-env';
import { useStoreState } from '@/store';
import cutOutIcon from './cutOutIcon.svg';
import styles from './index.module.less';

interface IProps {
    disableApply?: boolean;
    isEnterprise?: boolean;
    onCancelClick?: () => void;
    onApplyClick?: () => void;
}
const AIMattingOperateBtns: React.FC<IProps> = ({ disableApply, isEnterprise, onCancelClick, onApplyClick }) => {
    const { $t } = useLocaleStore();
    const userInfo = useStoreState((state) => state.userInfoModel.userInfo);
    const meidouInfo = useStoreState((state) => state.meidouModel.meidouInfo);
    const cutoutInfo = useStoreState((state) => state.cutoutModel.cutoutInfo);

    const left = isIntl ? meidouInfo?.available_amount : cutoutInfo.left;

    return (
        <div className={styles.operationWrap}>
            <div className={styles.operationBtns}>
                <Button
                    className={classNames([styles.btn, styles.btnCancel])}
                    onClick={() => {
                        onCancelClick?.();
                    }}
                >
                    {$t((v) => v.extensions.cancelText)}
                </Button>
                <Button
                    disabled={disableApply}
                    className={classNames([styles.btn, styles.btnApply])}
                    type="primary"
                    onClick={() => {
                        onApplyClick?.();
                    }}
                >
                    {$t((v) => v.extensions.okText)}
                    {/* 国内web，非会员且无张数 -> 不展示 */}
                    {/* 国内web，会员 -> 不展示 */}
                    {!clientInfo.isClient && !isEnterprise && ((!isIntl && !userInfo?.is_vip && left) || isIntl) ? (
                        <>
                            <img className={styles.icon} src={cutOutIcon} alt="" />
                            <span className={styles.count}>1</span>
                        </>
                    ) : null}
                </Button>
            </div>
        </div>
    );
};
export default AIMattingOperateBtns;
